<div
  class="tab-body-content"
  [@translateTab]="_position"
  (@translateTab.start)="_onTranslateTabStart($event)"
  (@translateTab.done)="_translateTabComplete.next($event)"
>
  <ng-template gcTabBodyHost></ng-template>
</div>
